module.exports = __webpack_public_path__ + "static/img/3bmlogo.d0c55db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3bmlogo.jpg
// module id = CGEe
// module chunks = 1